import { FormGroup } from "@material-ui/core";
import Select from "react-select";
import { Fragment } from "react";
import { Button, Card, CardBody } from "reactstrap";
import image from "./../../assets/images/logo.png";
import "./communities.scss";
import makeAnimated from "react-select/animated";
import moment from "moment";
import { UsersService } from "../../globals/services/users.service";
import { User } from "hc-entities";
const animatedComponents = makeAnimated();

export const CurrentCommunity = (props) => {
  const { currentCommunity, users, openFormEdit, action, setCurrentCommunity } =
    props;

  const getUserById = (id) => {
    const res = users.find((u) => u?.obj?._id === id);
    return res?.obj ? res.obj : null;
  };
  const renderCommunityMeta = () => {
    return (
      <div className="col-12">
        <div className="mb-3">
          <Button
            color={"primary"}
            onClick={() => openFormEdit(currentCommunity, action)}
          >
            Edit Community
          </Button>
        </div>
        <div className="mb-3">
          <img
            className="community-image"
            src={
              currentCommunity && currentCommunity.image
                ? currentCommunity.image
                : image
            }
            alt="community"
          />
        </div>
        <h3>{currentCommunity.name}</h3>
        <div className="d-flex flex-column align-items-start justify-content-start">
          <h5 className="">Created</h5>
          <p>
            {currentCommunity.hn_created
              ? moment(currentCommunity.hn_created).calendar(
                currentCommunity.hn_created
              )
              : ""}
          </p>
        </div>
        <div className="d-flex flex-column align-items-start justify-content-start">
          <h5 className="">Description</h5>
          <p>
            {currentCommunity?.description ? currentCommunity.description : ""}
          </p>
        </div>
      </div>
    );
  };

  const handleUserChange = async (selected) => {
    try {
      const usersService = UsersService();
      const oldUsersList = currentCommunity.users;
      const newUsersList = selected;
      let added = [],
        deleted = [];

      //ADDED NEW USERS
      if (newUsersList.length > oldUsersList.length) {
        newUsersList.map((n) => {
          if (!oldUsersList.some((o) => o.value === n.value)) {
            added.push(n);
          }
          return n;
        });
        //DELETED USERS
      } else {
        oldUsersList.map((o) => {
          if (!newUsersList.some((n) => n.value === o.value)) {
            deleted.push(o);
          }
          return o;
        });
      }

      setCurrentCommunity({
        ...currentCommunity,
        users: newUsersList,
      });

      if (added.length > 0) {
        await Promise.all(
          added.map(async (a) => {
            const user = getUserById(a.value);
            if (user) {
              if (user.userCommunities && Array.isArray(user.userCommunities))
                user.userCommunities.push({
                  _id: currentCommunity._id,
                  name: currentCommunity.name,
                });
              else
                user.userCommunities = [
                  { _id: currentCommunity._id, name: currentCommunity.name },
                ];

              if (user.communities && Array.isArray(user.communities))
                user.communities.push({ communityId: currentCommunity._id, role: "participant" });
              else user.communities = [{ communityId: currentCommunity._id, role: 'participant' }];
              const _user = new User({
                ...user,
              });
              await usersService.update(_user);
            }
          })
        );
      } else if (deleted.length > 0) {
        await Promise.all(
          deleted.map(async (d) => {
            const user = getUserById(d.value);
            if (user) {
              if (user.userCommunities)
                user.userCommunities = user.userCommunities.filter(
                  (c) => c._id !== currentCommunity._id
                );
              if (user.communities)
                user.communities = user.communities.filter(
                  (c) => c.communityId !== currentCommunity._id
                );
              const _user = new User({
                ...user,
              });
              await usersService.update(_user);
            }
          })
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  // const handleContentChange = (selected) => {
  // }

  const renderUserCommunityMembers = () => {
    return (
      <Fragment>
        {/* TODO: Render members */}
         <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
          <Select
            id="users"
            value={currentCommunity.users}
            isMulti={true}
            // onChange={(selected) => handleUserChange(selected)}
            options={users}
            classNamePrefix="select2-selection"
            closeMenuOnSelect={false}
            components={animatedComponents}
          />
        </FormGroup> 
      </Fragment>
    );
  };

  // const renderUserCommunityContent = () => {
  //     return <Fragment>
  //         <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
  //             <Select
  //                 id="posts"
  //                 value={[]}
  //                 isMulti={true}
  //                 onChange={(selected) => handleContentChange(selected)}
  //                 options={posts}
  //                 classNamePrefix="select2-selection"
  //                 closeMenuOnSelect={false}
  //                 components={animatedComponents}
  //             />
  //         </FormGroup>
  //     </Fragment>
  // }

  return currentCommunity ? (
    <Card>
      <CardBody>
        <div className="row">{renderCommunityMeta()}</div>

        <div className="row my-4 justify-content-center">
          <div className="d-flex justify-content-start">
            <h5 className="">Community Members</h5>
          </div>
          {renderUserCommunityMembers()}
        </div>

        {/* <div className="row my-4 justify-content-center">
                <div className="d-flex justify-content-start">
                    <h5 className="">
                        Community Content
                    </h5>
                </div>
                {renderUserCommunityContent()}
            </div> */}
      </CardBody>
    </Card>
  ) : null;
};
